import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';

class Ga4WrapperService {
    constructor() {
        if (window) {
            if (!Array.isArray(window.dataLayer)) {
                window.dataLayer = [];
            }
            this.dataLayer = window.dataLayer;
        }
    }
    callEvent(objEvent) {
        if (this.dataLayer)
            this.dataLayer.push(objEvent);
    }
}
Ga4WrapperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: Ga4WrapperService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
Ga4WrapperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: Ga4WrapperService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: Ga4WrapperService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return []; } });

class Ga4WrapperModule {
}
Ga4WrapperModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: Ga4WrapperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
Ga4WrapperModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: Ga4WrapperModule });
Ga4WrapperModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: Ga4WrapperModule, providers: [Ga4WrapperService] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: Ga4WrapperModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [Ga4WrapperService],
                }]
        }] });

/*
 * Public API Surface of ga4-wrapper
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Ga4WrapperModule, Ga4WrapperService };
